import { PostCardStack } from './post-card-stack';
import type { CardData } from '../../../../print-cards/card-data';
import { Type } from '@angular/core';
import { CardBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/card-background.component';
import { PrintCardContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/shared/print-card-content.component';
import { TrueNorthLandscapeCardStackBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/post-cards-4x6/true-north-landscape-card-stack-background/true-north-landscape-card-stack-background.component';
import { TrueNorthLandscapeCardStackContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/post-cards-4x6/true-north-post-card-stack-content/true-north-landscape-card-stack-content/true-north-landscape-card-stack-content.component';

export class TrueNorthLandscapeCardStack extends PostCardStack {
  getCardBackgroundComponent(cardData: CardData): Type<CardBackgroundComponent> | null {
    return TrueNorthLandscapeCardStackBackgroundComponent;
  }

  getCardContentComponent(cardData: CardData): Type<PrintCardContentComponent> | null {
    return TrueNorthLandscapeCardStackContentComponent;
  }

  nonPerforatedBleedBorderInInches(): number {
    return 0;
  }
}
